import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import randomColor from "randomcolor";
import { TrimText } from "../common/TrimText";
import { formatOnlyDateRange, getSubjectStatus, subjectDuration } from "../../utils/commonFunction";
import ViewProfile from "../course/ViewProfile";
import { buildStatusChip, markChipStyle, headerColor,GetLearningMethodText, GetCampusText } from "./ProgramHelperUtils.js";
import { ModuleCards, ModuleCard, ModuleCardHeader, SvgLayer, StatusRow, StatusLeft, ChipBase, CodeIntake, HeaderBottom, TitleRow, DateRow, ProgressSection, ProgressWrapper, ProgressTrack, ProgressFillLearning, ProgressFillAssessment, ProgressFooter, TotalProgressText, LegendRow, LegendItem, Dot } from "./ProgramStyledComponents.js";
import MarkChip from "./markChip";
import { tokens } from "../../public/tokens.js";
import { ReactComponent as Logo } from "../../assets/images_1/aieLogoIcon.svg";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer.js";

export default function SubjectGroupList({
  subjectList,
  qualification,
  qid,
  completed_subject,
  showSideBar,
  setShowSideBar,
  loading,
  lockGrades
}) {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isWithHeldStatus = localStorage.getItem("resultWithHeld");
  const lockedGrades = lockGrades

  const [color, setColor] = useState(null);
  const popRef = useRef(null)
  useEffect(() => {
    setColor(
      randomColor({
        luminosity: "dark",
      })
    );
  }, [qualification]);

  useEffect(() => {
    if (window.innerWidth < 769) {
      setShowSideBar(false)
    } else {
      setShowSideBar(true)
    }
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [showSideBar]);

  const getTextLength = () => {
    if (windowWidth < 321) {
      return 76;
    }

    if (windowWidth < 376) {
      return 90;
    }

    if (windowWidth < 426) {
      return 110;
    }

    if (windowWidth < 769) {
      return 90;
    }

    if (windowWidth < 1025) {
      return showSideBar ? 80 : 135;
    }

    if (windowWidth < 1442) {
      return showSideBar ? 145 : 200;
    }

    if (windowWidth < 1920) {
      return showSideBar ? 180 : 230;
    }

    if (windowWidth < 2560) {
      return showSideBar ? 235 : 350;
    }

    return 235
  };

  if (loading) {
    return (
      <div>
        <SkeletonContainer height={getSkeletonHeight(28)}/>
      </div>
    );
  }

  return (
    <>
      <ModuleCards className="moduleCardContainer">
        {subjectList?.map((ele, i) => {
          const isForcedFinished = ele.subjectStatus === "Finished" || (ele.show_results === 1 && ele.subjectStatus !== "Not Yet Published");          
          const chip = buildStatusChip(
            (isForcedFinished ? "Finished" : ele.subjectStatus),
            isWithHeldStatus == "true" ? "witheld" : ele.show_results === 1 ? ele?.studentResult?.pass_status : "");
          const hasCode = !!ele?.code;
          const hasIntake = !!(ele?.number && ele?.year);
          const isUpcoming = ele?.subjectStatus === "Not Yet Published";
          const assessment = ele?.progress?.totalAssessmentPercentage || 0;
          const learning = ele?.progress?.totalLearningMaterialPercentage || 0;
          const assessmentOnTop = assessment < learning;
          
          return (
            <ModuleCard
              to={`/course/${qid}/subject/${ele?.intake_id}`}
              style={isUpcoming ? { opacity: 0.5 } : undefined}
              key={ele.intake_id}
              title={ele?.name}
              onClick={(e) => {
                if (ele?.subjectStatus === "Not Yet Published") {
                  e.preventDefault();
                }
              }}
              ref={popRef}
            >

              <ModuleCardHeader
                style={headerColor((isForcedFinished ? "Finished" : ele.subjectStatus),
                  isWithHeldStatus == "true" ? "witheld" : ele.show_results === 1 ? ele?.studentResult?.pass_status : "")
                }
              >
                <SvgLayer>
                  <Logo/>
                </SvgLayer>
                <StatusRow>
                  <StatusLeft>
                    <ChipBase style={chip.style}>
                      {chip.label}
                    </ChipBase>
                    {(hasCode || hasIntake) && (
                      <CodeIntake>
                        {hasCode && ele.code}
                        {hasCode && hasIntake && " | "}
                        {hasIntake && (
                          <>Intake {ele.number}, {ele.year}</>
                        )}
                      </CodeIntake>
                    )}
                  </StatusLeft>
                  {isForcedFinished && ele.show_results === 1 &&
                    ele?.studentResult?.pass_status !== "witheld" && (
                      <div>
                        <MarkChip
                          passed={ele?.studentResult?.pass_status}
                          mark={ele?.studentResult?.gradeText}
                        />
                      </div>
                    )}
                </StatusRow>
                <HeaderBottom>
                    <TitleRow>
                      {/* {ele?.name ? TrimText(ele?.name, 50) : ""} */}
                      {ele?.name}
                    </TitleRow>
                    <DateRow>
                      <i className="fa-light fa-calendar-clock"></i>
                      {ele?.start && ele?.end
                        ? formatOnlyDateRange(ele?.start, ele?.end) 
                        : "Invalid Date"}
                      {(ele?.type || ele?.campus) && (
                        <>
                          <i className="fa-light fa-building-columns" />
                          {ele?.type && GetLearningMethodText(ele.type)}
                          {ele?.type && ele?.campus ? " - " : ""}
                          {ele?.campus && GetCampusText(ele.campus)}
                        </>
                      )}
                  </DateRow>
                </HeaderBottom>
              </ModuleCardHeader>
              <ProgressSection>
                <ProgressWrapper>
                  <ProgressTrack>
                    {assessmentOnTop ? (
                      <ProgressFillLearning
                        style={{ width: `${Math.max(assessment, learning)}%` }}
                      />
                    ) : (
                      <ProgressFillAssessment
                        style={{ width: `${Math.max(assessment, learning)}%` }}
                      />
                    )}
                    {assessmentOnTop ? (
                      <ProgressFillAssessment
                        style={{ width: `${Math.min(assessment, learning)}%` }}
                      />
                    ) : (
                      <ProgressFillLearning
                        style={{ width: `${Math.min(assessment, learning)}%` }}
                      />
                    )}
                  </ProgressTrack>
                  <ProgressFooter>
                    <TotalProgressText>
                      {(ele?.progress?.progressBar ?? 0)}% Complete
                    </TotalProgressText>
                    <LegendRow>
                      <LegendItem>
                        <Dot
                          style={{
                            backgroundColor: tokens.colors.brand["fresh-green"]["700"],
                          }}
                        />
                        Assessments
                      </LegendItem>
                      <LegendItem>
                        <Dot
                          style={{
                            backgroundColor: tokens.colors.brand["fresh-green"]["400"],
                          }}
                        />
                        Learning Material
                      </LegendItem>
                    </LegendRow>
                  </ProgressFooter>
                </ProgressWrapper>
                </ProgressSection>              
            </ModuleCard>
          );
        })}
      </ModuleCards>
    </>
  );
}
